export const timezones = [
  { id: '1', value: 'Etc/GMT+12', label: 'Baker Island (GMT-12)' },
  { id: '2', value: 'Pacific/Pago_Pago', label: 'Pago Pago (GMT-11)' },
  { id: '3', value: 'Pacific/Honolulu', label: 'Honolulu (GMT-10)' },
  {
    id: '4',
    value: 'Pacific/Marquesas',
    label: 'Marquesas Islands (GMT-9:30)',
  },
  { id: '5', value: 'America/Anchorage', label: 'Anchorage (GMT-8)' },
  { id: '6', value: 'America/Los_Angeles', label: 'Los Angeles (GMT-7)' },
  { id: '7', value: 'America/Phoenix', label: 'Phoenix (GMT-7)' },
  { id: '8', value: 'America/Denver', label: 'Denver (GMT-6)' },
  { id: '9', value: 'America/Mexico_City', label: 'Mexico City (GMT-6)' },
  { id: '10', value: 'America/Chicago', label: 'Chicago (GMT-5)' },
  { id: '11', value: 'America/Lima', label: 'Lima (GMT-5)' },
  { id: '12', value: 'America/New_York', label: 'New York (GMT-4)' },
  { id: '54', value: 'America/Toronto', label: 'Toronto (GMT-4)' },
  { id: '13', value: 'America/Caracas', label: 'Caracas (GMT-4)' },
  { id: '14', value: 'America/Santiago', label: 'Santiago (GMT-4)' },
  { id: '15', value: 'America/Halifax', label: 'Halifax (GMT-3)' },
  { id: '16', value: 'America/Buenos_Aires', label: 'Buenos Aires (GMT-3)' },
  { id: '17', value: 'America/Sao_Paulo', label: 'Sao Paulo (GMT-3)' },
  { id: '18', value: 'America/St_Johns', label: "St. John's (GMT-2:30)" },
  {
    id: '19',
    value: 'America/Noronha',
    label: 'Fernando de Noronha (GMT-2:30)',
  },
  { id: '20', value: 'Atlantic/Azores', label: 'Azores (GMT)' },
  { id: '21', value: 'Europe/London', label: 'London (GMT)' },
  { id: '22', value: 'Atlantic/Reykjavik', label: 'Reykjavik (GMT)' },
  { id: '23', value: 'Europe/Paris', label: 'Paris (GMT+1)' },
  { id: '24', value: 'Africa/Lagos', label: 'Lagos (GMT+1)' },
  { id: '25', value: 'Africa/Johannesburg', label: 'Johannesburg (GMT+2)' },
  { id: '53', value: 'Asia/Jerusalem', label: 'Jerusalem (GMT+3)' },
  { id: '26', value: 'Africa/Cairo', label: 'Cairo (GMT+3)' },
  { id: '27', value: 'Europe/Athens', label: 'Athens (GMT+3)' },
  { id: '28', value: 'Europe/Moscow', label: 'Moscow (GMT+3)' },
  { id: '29', value: 'Africa/Nairobi', label: 'Nairobi (GMT+3)' },
  { id: '30', value: 'Asia/Tehran', label: 'Tehran (GMT+3:30)' },
  { id: '31', value: 'Asia/Dubai', label: 'Dubai (GMT+4)' },
  { id: '32', value: 'Asia/Yerevan', label: 'Yerevan (GMT+4)' },
  { id: '33', value: 'Asia/Kabul', label: 'Kabul (GMT+4:30)' },
  { id: '34', value: 'Asia/Karachi', label: 'Karachi (GMT+5)' },
  { id: '35', value: 'Asia/Kolkata', label: 'Mumbai (GMT+5:30)' },
  { id: '36', value: 'Asia/Kathmandu', label: 'Kathmandu (GMT+5:45)' },
  { id: '37', value: 'Asia/Dhaka', label: 'Dhaka (GMT+6)' },
  { id: '38', value: 'Asia/Yangon', label: 'Yangon (GMT+6:30)' },
  { id: '39', value: 'Asia/Bangkok', label: 'Bangkok (GMT+7)' },
  { id: '55', value: 'Asia/Manila', label: 'Manila (GMT+8)' },
  { id: '40', value: 'Asia/Shanghai', label: 'Beijing (GMT+8)' },
  { id: '41', value: 'Asia/Singapore', label: 'Singapore (GMT+8)' },
  { id: '42', value: 'Australia/Perth', label: 'Perth (GMT+9)' },
  { id: '43', value: 'Asia/Tokyo', label: 'Tokyo (GMT+9)' },
  { id: '44', value: 'Australia/Adelaide', label: 'Adelaide (GMT+9:30)' },
  { id: '45', value: 'Australia/Darwin', label: 'Darwin (GMT+9:30)' },
  { id: '46', value: 'Australia/Sydney', label: 'Sydney (GMT+10)' },
  { id: '47', value: 'Pacific/Port_Moresby', label: 'Port Moresby (GMT+10)' },
  {
    id: '48',
    value: 'Australia/Lord_Howe',
    label: 'Lord Howe Island (GMT+10:30)',
  },
  { id: '49', value: 'Pacific/Honiara', label: 'Honiara (GMT+11)' },
  { id: '50', value: 'Pacific/Auckland', label: 'Auckland (GMT+12)' },
  { id: '51', value: 'Pacific/Tongatapu', label: "Nuku'alofa (GMT+13)" },
  { id: '52', value: 'Pacific/Kiritimati', label: 'Kiritimati (GMT+14)' },
];
